import { v2 } from "utils/apiClients";

let csrfToken = null;
let seedPromise = null;

function readCsrfFromCookie() {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export const seedCsrfToken = async () => {
  if (csrfToken) return csrfToken;
  if (seedPromise) return seedPromise;

  seedPromise = v2
    .get("/authentication/csrf-token")
    .then((res) => {
      csrfToken =
        res.data?.data?.csrfToken ||
        res.data?.csrfToken ||
        readCsrfFromCookie();

      if (!csrfToken) {
        throw new Error("CSRF token missing from response");
      }

      return csrfToken;
    })
    .catch((err) => {
      seedPromise = null;

      const cookieToken = readCsrfFromCookie();
      if (cookieToken) {
        csrfToken = cookieToken;
        return csrfToken;
      }

      const status = err?.response?.status;
      console.error(
        `[csrf] seed failed (${status || "network"}):`,
        err?.response?.data || err?.message || err,
      );
      throw err;
    });

  return seedPromise;
};

export const getCsrfToken = () => csrfToken || readCsrfFromCookie();

export const resetCsrfToken = () => {
  csrfToken = null;
  seedPromise = null;
};
